// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-entry-context-menu-base__item {
  color: var(--g-color-text-complementary);
}
.dl-entry-context-menu-base__item:not(.dl-entry-context-menu-base__item_danger):hover {
  color: var(--g-color-text-primary);
}`, "",{"version":3,"sources":["webpack://./src/ui/components/EntryContextMenu/EntryContextMenuBase/EntryContextMenuBase.scss"],"names":[],"mappings":"AACI;EACI,wCAAA;AAAR;AAEQ;EACI,kCAAA;AAAZ","sourcesContent":[".dl-entry-context-menu-base__item {\n  color: var(--g-color-text-complementary);\n}\n.dl-entry-context-menu-base__item:not(.dl-entry-context-menu-base__item_danger):hover {\n  color: var(--g-color-text-primary);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
